// Scramble de texto (spec §8.7/§15.1). Solo puntero preciso, sin movimiento
// reducido, texto ≤ 40 caracteres.
//
// El texto se envuelve en un contenedor con un "espaciador" invisible que
// conserva el texto original: así el ancho del botón queda FIJO y no crece
// ni encoge mientras los caracteres cambian.
export function initScramble() {
	const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
	const precisePointer = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
	if (reducedMotion || !precisePointer) return;

	const characters = "+=-_?¨'^·";

	document.querySelectorAll("[data-scramble]").forEach((element) => {
		if (element.dataset.scrambleBound) return;

		const originalText = element.textContent.trim();
		if (!originalText || originalText.length > 40) return;
		element.dataset.scrambleBound = "1";

		// Estructura: holder > (spacer invisible + texto en posición absoluta).
		const holder = document.createElement("span");
		holder.className = "psyque-scramble";
		const spacer = document.createElement("span");
		spacer.className = "psyque-scramble__spacer";
		spacer.setAttribute("aria-hidden", "true");
		spacer.textContent = originalText;

		element.parentNode.insertBefore(holder, element);
		holder.appendChild(spacer);
		element.classList.add("psyque-scramble__text");
		holder.appendChild(element);

		let timer = null;

		const run = () => {
			let iteration = 0;
			clearInterval(timer);

			timer = window.setInterval(() => {
				element.textContent = originalText
					.split("")
					.map((character, index) => {
						if (character === " ") return " ";
						if (index < iteration) return originalText[index];
						return characters[Math.floor(Math.random() * characters.length)];
					})
					.join("");

				if (iteration >= originalText.length) {
					clearInterval(timer);
					element.textContent = originalText;
				}

				iteration += 0.5;
			}, 18);
		};

		const reset = () => {
			clearInterval(timer);
			element.textContent = originalText;
		};

		// El hover se escucha en el propio texto — no en toda la tarjeta que
		// lo contenga. El foco sí sube al enlace, que es lo focusable.
		holder.addEventListener("mouseenter", run);
		holder.addEventListener("mouseleave", reset);

		const focusHost = element.closest("a, button");
		if (focusHost) {
			focusHost.addEventListener("focus", run);
			focusHost.addEventListener("blur", reset);
		}
	});
}
